import React, { useEffect, useState } from 'react'
import { Grid, Badge, useMediaQuery } from '@mui/material'
import { TextBold, TextSemiBold } from '../../../commonComponents/TextStyling'
import JobPost from '../../../commonComponents/JobPost'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/styles'

export default function WorkedOn (props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens
  const [workedOnData, setWorkedOnData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(function () {
    getJobsYouWorkedOn()
  }, [])

  function getJobsYouWorkedOn () {
    serverData.workedOnData(
      {},
      result => {
        if (result.status) {
          setWorkedOnData(result.response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ display: 'flex', marginBottom: '24px' }}>
        <TextSemiBold style={{ fontSize: matches ? '18px' : '24px' }}>
          Jobs you worked on
        </TextSemiBold>
        <Badge
          badgeContent={workedOnData?.length}
          color='primary'
          style={{ left: 10 }}
        />
      </Grid>
      <Grid item xs={12}>
        <JobPost data={workedOnData} loading={loading} />
      </Grid>
    </Grid>
  )
}
